import fetchAPI from '../fetchAPI';

/**
 * Soft-deletes a custom AI markup tier by its `type` slug.
 *
 * The server refuses system tiers, the AI fallback tier, and any tier that still
 * has billing accounts on it — the 400 message explains which guard rejected it,
 * so surface it to the admin rather than showing a generic failure.
 */
export const callDeleteMarkup = async (
  type: string
): Promise<iResponse<{ code: number; message: string }>> => {
  const response: iResponse<{ code: number; message: string }> = await fetchAPI({
    method: `DELETE`,
    route: `markup`,
    id: type
  });
  return response;
};

export default callDeleteMarkup;
